module.exports = __webpack_public_path__ + "img/箭头.9a777c88.svg";